import { useEffect } from 'react';
import { useObserver } from 'mobx-react';
import models from '@/models/index';
import { loadScript } from './common';

declare interface WatermarkConfiguration {
  /** 字体颜色 */
  color?: string;

  /** 水印显示最大宽度 */
  maxWidth?: number;

  /** 透明度 */
  opacity?: number;

  /** 逆时针倾斜角度 */
  rotate?: number;

  /** 字体大小 */
  size?: number;

  /** 水印文本 */
  text?: string;

  /** 水印元素水平方向上的间距 */
  xSpace?: number;

  /** 水印元素开始绘制的水平位置 */
  xStart?: number;

  /** 水印元素竖直方向上的间距 */
  ySpace?: number;

  /** 水印元素开始绘制的竖直位置 */
  yStart?: number;

  /** 水印元素的层叠优先级 */
  zIndex?: number;
}

const pcConfig = {
  /** 字体颜色 */
  color: '#8f8f8f',
  /** 水印显示最大宽度 */
  maxWidth: 140,
  /** 透明度 */
  opacity: 0.1,
  /** 逆时针倾斜角度 */
  rotate: 15,
  /** 字体大小 */
  size: 12,
  /** 水印元素水平方向上的间距 */
  xSpace: 150,
  /** 水印元素开始绘制的水平位置 */
  xStart: 0,
  /** 水印元素竖直方向上的间距 */
  ySpace: 100,
  /** 水印元素开始绘制的竖直位置 */
  yStart: 0,
  /** 水印元素的层叠优先级 */
  zIndex: 9999,
};

const mobileConfig = {
  /** 字体颜色 */
  color: '#8f8f8f',
  /** 水印显示最大宽度 */
  maxWidth: 140,
  /** 透明度 */
  opacity: 0.1,
  /** 逆时针倾斜角度 */
  rotate: 15,
  /** 字体大小 */
  size: 12,
  /** 水印元素水平方向上的间距 */
  xSpace: 40,
  /** 水印元素开始绘制的水平位置 */
  xStart: 10,
  /** 水印元素竖直方向上的间距 */
  ySpace: 80,
  /** 水印元素开始绘制的竖直位置 */
  yStart: 0,
  /** 水印元素的层叠优先级 */
  zIndex: 9999,
};

function loadMark() {
  return new Promise((resolve) => {
    if (window.WaterMark) {
      resolve(window.WaterMark);
    } else {
      loadScript(`${process.env.NODE_ENV === 'production' ? '/meet/' : '/'}js/nis.wm.js`).then(
        () => {
          resolve(window.WaterMark);
        }
      );
    }
  });
}

export default function waterMarker(options: WatermarkConfiguration) {
  const defaultMarkConfig = window.isMobile ? mobileConfig : pcConfig;
  loadMark().then(() => {
    window.WaterMark.clear();
    window.WaterMark.mark({
      ...defaultMarkConfig,
      ...options,
    });
  });
}

export function useWaterMarker() {
  const { waterMark } = useObserver(() => {
    return {
      waterMark: models.user.waterMark,
    };
  });
  useEffect(() => {
    if (waterMark?.text && waterMark?.opacity) {
      waterMarker({
        text: waterMark.text,
        opacity: waterMark.opacity,
      });
    } else {
      loadMark().then(() => {
        window.WaterMark?.clear();
      });
    }
  }, [waterMark]);
}
